import * as WS from '../webServices/cyMyManager';
import { formatDate } from '../webServices/cyMyManagerUtils';
type TablePromoProps = {
    promo: WS.Plus.IF.Promozione;
    passToModal: () => void;
};

export default function TablePromo(props: TablePromoProps):JSX.Element {
    
    return (
        <tr onClick={props.passToModal} >
            <td className='table-cell-mobile'>
                <span className='table-label-mobile' style={{width: 'fit-content'}}>{props.promo.CodicePromo}</span>
                <span className='table-title-mobile'>{props.promo.Descrizioni[0].Descrizione}</span>
                <span className='table-subtitle-mobile'><strong>Abbonamento:</strong> {props.promo.Abbonamento.Nome}</span>
                <span className='table-subtitle-mobile'><strong>Valida dal:</strong> {formatDate(props.promo.DataDa)} al {formatDate(props.promo.DataA)}</span>
            </td>
        </tr>
    )
}